import React, { FC } from 'react';
import { Asset, CheckmarkIcon, WarningIcon } from '@clearcover/atlas';

import styles from './styles.module.css';
import classnames from 'classnames';

export type LicenseStatusType =
  | 'valid_license'
  | 'invalid_license'
  | 'unknown_license_status'
  | 'no_license_found';

const STATUS_MAP: Record<
  LicenseStatusType,
  { icon: typeof WarningIcon; label: string }
> = {
  valid_license: {
    icon: CheckmarkIcon,
    label: 'Valid license',
  },
  invalid_license: {
    icon: WarningIcon,
    label: 'Invalid license',
  },
  unknown_license_status: {
    icon: WarningIcon,
    label: 'Unknown license status',
  },
  no_license_found: {
    icon: WarningIcon,
    label: 'No license found',
  },
};

export const LicenseStatus: FC<{
  status: LicenseStatusType;
}> = ({ status }) => {
  return (
    <div className={styles.status}>
      <Asset
        icon={STATUS_MAP[status].icon}
        description={status}
        height={16}
        width={16}
        className={classnames(styles.icon, styles[status])}
      />
      {STATUS_MAP[status].label}
    </div>
  );
};
